/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ActivityDto,
  ActivityDtoPagination,
  ActivityInformationDto,
  ActivityModelDtoPagination,
  DateOnlyActivityInformationDtoListTuple,
  GetActivityInformationForTileParams,
  GetActivityInformationGroupByDateParams,
  GetActivityInformationParams,
  GetActivityParams,
  GetPaginatedClientActivitiesParams,
  PaginatedActivitiesRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPaginatedActivitiesUrl = () => {




  return `/api/Activity/GetPaginatedActivities`
}

export const getPaginatedActivities = async (paginatedActivitiesRequest: PaginatedActivitiesRequest, options?: Parameters<typeof customInstance>[1]): Promise<ActivityDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ActivityDtoPagination>(getGetPaginatedActivitiesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paginatedActivitiesRequest)
  }
);}





export const getGetPaginatedActivitiesMutationKey = () => ['getPaginatedActivities'] as const;

export const getGetPaginatedActivitiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedActivities>>, TError,GetPaginatedActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedActivities>>, TError,GetPaginatedActivitiesMutationVariables, TContext> => {

const mutationKey = getGetPaginatedActivitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedActivities>>, GetPaginatedActivitiesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedActivities(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedActivitiesMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedActivities>>>
    export type GetPaginatedActivitiesMutationBody = BodyType<PaginatedActivitiesRequest>
    export type GetPaginatedActivitiesMutationError = ErrorType<unknown>
    export type GetPaginatedActivitiesMutationVariables = {data: BodyType<PaginatedActivitiesRequest>}

    export const useGetPaginatedActivities = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedActivities>>, TError,GetPaginatedActivitiesMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedActivities>>,
        TError,
        GetPaginatedActivitiesMutationVariables,
        TContext
      > => {
      return useMutation(getGetPaginatedActivitiesMutationOptions(options), queryClient);
    }
    export const getGetPaginatedClientActivitiesUrl = (params?: GetPaginatedClientActivitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["productionIds","activityTypeNodes","locationTreeNodes","activityStatusTreeNodes","sorting","include"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Activity/GetPaginatedClientActivities?${stringifiedParams}` : `/api/Activity/GetPaginatedClientActivities`
}

export const getPaginatedClientActivities = async (params?: GetPaginatedClientActivitiesParams, options?: Parameters<typeof customInstance>[1]): Promise<ActivityModelDtoPagination> => {

  return customInstance<ActivityModelDtoPagination>(getGetPaginatedClientActivitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaginatedClientActivitiesQueryKey = (params?: GetPaginatedClientActivitiesParams,) => {
    return [
    `/api/Activity/GetPaginatedClientActivities`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPaginatedClientActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(params?: GetPaginatedClientActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedClientActivitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedClientActivities>>> = ({ signal }) => getPaginatedClientActivities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaginatedClientActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedClientActivities>>>
export type GetPaginatedClientActivitiesQueryError = ErrorType<unknown>


export function useGetPaginatedClientActivities<TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPaginatedClientActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedClientActivities>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedClientActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedClientActivities<TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedClientActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedClientActivities>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedClientActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedClientActivities<TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedClientActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaginatedClientActivities<TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedClientActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaginatedClientActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedClientActivitiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(params?: GetPaginatedClientActivitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedClientActivitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedClientActivities>>> = ({ signal }) => getPaginatedClientActivities(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPaginatedClientActivitiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedClientActivities>>>
export type GetPaginatedClientActivitiesSuspenseQueryError = ErrorType<unknown>


export function useGetPaginatedClientActivitiesSuspense<TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPaginatedClientActivitiesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedClientActivitiesSuspense<TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedClientActivitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedClientActivitiesSuspense<TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedClientActivitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaginatedClientActivitiesSuspense<TData = Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedClientActivitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedClientActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaginatedClientActivitiesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityUrl = (params?: GetActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Activity/GetActivity?${stringifiedParams}` : `/api/Activity/GetActivity`
}

export const getActivity = async (params?: GetActivityParams, options?: Parameters<typeof customInstance>[1]): Promise<ActivityDto> => {

  return customInstance<ActivityDto>(getGetActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActivityQueryKey = (params?: GetActivityParams,) => {
    return [
    `/api/Activity/GetActivity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityQueryOptions = <TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(params?: GetActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivity>>> = ({ signal }) => getActivity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getActivity>>>
export type GetActivityQueryError = ErrorType<unknown>


export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivity>>,
          TError,
          Awaited<ReturnType<typeof getActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(
 params?: GetActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivity>>,
          TError,
          Awaited<ReturnType<typeof getActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(
 params?: GetActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(
 params?: GetActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivitySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(params?: GetActivityParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivity>>> = ({ signal }) => getActivity(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetActivitySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActivity>>>
export type GetActivitySuspenseQueryError = ErrorType<unknown>


export function useGetActivitySuspense<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivitySuspense<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(
 params?: GetActivityParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivitySuspense<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(
 params?: GetActivityParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivitySuspense<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<unknown>>(
 params?: GetActivityParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivitySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityInformationUrl = (params?: GetActivityInformationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Activity/GetActivityInformation?${stringifiedParams}` : `/api/Activity/GetActivityInformation`
}

export const getActivityInformation = async (params?: GetActivityInformationParams, options?: Parameters<typeof customInstance>[1]): Promise<ActivityInformationDto[]> => {

  return customInstance<ActivityInformationDto[]>(getGetActivityInformationUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActivityInformationQueryKey = (params?: GetActivityInformationParams,) => {
    return [
    `/api/Activity/GetActivityInformation`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityInformationQueryOptions = <TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(params?: GetActivityInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityInformationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityInformation>>> = ({ signal }) => getActivityInformation(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityInformation>>>
export type GetActivityInformationQueryError = ErrorType<unknown>


export function useGetActivityInformation<TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityInformationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityInformation>>,
          TError,
          Awaited<ReturnType<typeof getActivityInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformation<TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityInformation>>,
          TError,
          Awaited<ReturnType<typeof getActivityInformation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformation<TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityInformation<TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityInformationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityInformationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(params?: GetActivityInformationParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityInformationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityInformation>>> = ({ signal }) => getActivityInformation(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetActivityInformationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityInformation>>>
export type GetActivityInformationSuspenseQueryError = ErrorType<unknown>


export function useGetActivityInformationSuspense<TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityInformationParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationSuspense<TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationSuspense<TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityInformationSuspense<TData = Awaited<ReturnType<typeof getActivityInformation>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityInformationSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityInformationGroupByDateUrl = (params?: GetActivityInformationGroupByDateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Activity/GetActivityInformationGroupByDate?${stringifiedParams}` : `/api/Activity/GetActivityInformationGroupByDate`
}

export const getActivityInformationGroupByDate = async (params?: GetActivityInformationGroupByDateParams, options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyActivityInformationDtoListTuple[]> => {

  return customInstance<DateOnlyActivityInformationDtoListTuple[]>(getGetActivityInformationGroupByDateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActivityInformationGroupByDateQueryKey = (params?: GetActivityInformationGroupByDateParams,) => {
    return [
    `/api/Activity/GetActivityInformationGroupByDate`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityInformationGroupByDateQueryOptions = <TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(params?: GetActivityInformationGroupByDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityInformationGroupByDateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>> = ({ signal }) => getActivityInformationGroupByDate(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityInformationGroupByDateQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>>
export type GetActivityInformationGroupByDateQueryError = ErrorType<unknown>


export function useGetActivityInformationGroupByDate<TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityInformationGroupByDateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityInformationGroupByDate>>,
          TError,
          Awaited<ReturnType<typeof getActivityInformationGroupByDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationGroupByDate<TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationGroupByDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityInformationGroupByDate>>,
          TError,
          Awaited<ReturnType<typeof getActivityInformationGroupByDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationGroupByDate<TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationGroupByDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityInformationGroupByDate<TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationGroupByDateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityInformationGroupByDateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityInformationGroupByDateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(params?: GetActivityInformationGroupByDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityInformationGroupByDateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>> = ({ signal }) => getActivityInformationGroupByDate(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetActivityInformationGroupByDateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>>
export type GetActivityInformationGroupByDateSuspenseQueryError = ErrorType<unknown>


export function useGetActivityInformationGroupByDateSuspense<TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityInformationGroupByDateParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationGroupByDateSuspense<TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationGroupByDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationGroupByDateSuspense<TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationGroupByDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityInformationGroupByDateSuspense<TData = Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationGroupByDateParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationGroupByDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityInformationGroupByDateSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityInformationForTileUrl = (params?: GetActivityInformationForTileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Activity/GetActivityInformationForTile?${stringifiedParams}` : `/api/Activity/GetActivityInformationForTile`
}

export const getActivityInformationForTile = async (params?: GetActivityInformationForTileParams, options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyActivityInformationDtoListTuple[]> => {

  return customInstance<DateOnlyActivityInformationDtoListTuple[]>(getGetActivityInformationForTileUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActivityInformationForTileQueryKey = (params?: GetActivityInformationForTileParams,) => {
    return [
    `/api/Activity/GetActivityInformationForTile`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityInformationForTileQueryOptions = <TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(params?: GetActivityInformationForTileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityInformationForTileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityInformationForTile>>> = ({ signal }) => getActivityInformationForTile(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityInformationForTileQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityInformationForTile>>>
export type GetActivityInformationForTileQueryError = ErrorType<unknown>


export function useGetActivityInformationForTile<TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityInformationForTileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityInformationForTile>>,
          TError,
          Awaited<ReturnType<typeof getActivityInformationForTile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationForTile<TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationForTileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityInformationForTile>>,
          TError,
          Awaited<ReturnType<typeof getActivityInformationForTile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationForTile<TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationForTileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityInformationForTile<TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationForTileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityInformationForTileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityInformationForTileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(params?: GetActivityInformationForTileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityInformationForTileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityInformationForTile>>> = ({ signal }) => getActivityInformationForTile(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetActivityInformationForTileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityInformationForTile>>>
export type GetActivityInformationForTileSuspenseQueryError = ErrorType<unknown>


export function useGetActivityInformationForTileSuspense<TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityInformationForTileParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationForTileSuspense<TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationForTileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityInformationForTileSuspense<TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationForTileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityInformationForTileSuspense<TData = Awaited<ReturnType<typeof getActivityInformationForTile>>, TError = ErrorType<unknown>>(
 params?: GetActivityInformationForTileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityInformationForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityInformationForTileSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






